// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b0782051","400":"ca5f1cb9"}[chunkId] + ".chunk.js";
};